import { faGear } from "@fortawesome/pro-duotone-svg-icons/faGear";

import { type Breadcrumb } from "@application/types/breadcrumb";

export const DASHBOARD_SETTINGS_LINK: Breadcrumb = {
  icon: faGear,
  name: "Settings",
  to: "/dashboard/settings",
};
